import { huge, hugeOne, maxHuge, type HugeNumber } from "@/shared/numbers";
import { resolveOHovHovCoreGainPostAcquisitionMultiplier } from "./hovSkillEffects";

// Tooltip preview helpers for Hov skill rows. They intentionally bypass the
// "skill acquired" gate so an unacquired row can show the effective value the
// skill would produce against the current target if acquired now, rather than
// collapsing to x1. When the skill is already acquired the returned value
// equals the runtime effect since the underlying formulas are equivalent;
// only the gate differs.

export function resolveAmplifierGainOHovPreviewMultiplier(params: {
  readonly oHovPower: HugeNumber;
}): HugeNumber {
  return maxHuge(hugeOne(), params.oHovPower);
}

export function resolveOHovHovCoreGainPreviewMultiplier(params: {
  readonly achievementScalingUnlocked: boolean;
  readonly oHovPower: HugeNumber;
}): HugeNumber {
  return resolveOHovHovCoreGainPostAcquisitionMultiplier({
    achievementScalingUnlocked: params.achievementScalingUnlocked,
    oHovPower: params.oHovPower,
  });
}

export function resolveRaBambooAmplifierPreviewMultiplier(params: {
  readonly clearedWallKindCount: number;
}): HugeNumber {
  return huge(1 + Math.max(0, params.clearedWallKindCount));
}

export function resolveRaPineAmplifierPreviewMultiplier(params: {
  readonly oHovCurrentRunGameElapsedMs: number;
}): HugeNumber {
  const elapsedSeconds = params.oHovCurrentRunGameElapsedMs / 1000;
  if (!Number.isFinite(elapsedSeconds) || elapsedSeconds <= 0) {
    return hugeOne();
  }
  return huge(1 + elapsedSeconds ** 0.8 / 100);
}
